<template>
  <p class="firebase-help-message">
    {{ message }}
    <b-button
      v-if="showCreateButton"
      @click="create()"
      size="is-small"
      type="is-danger"
      outlined>
        Создать
    </b-button>
  </p>
</template>

<style lang="scss" scoped>
.firebase-help-message {
  margin-top: 10px;
}
</style>

<script>
import { isEmpty } from 'lodash'
export default {
  props: {
    androidPackage: String,
    firebaseProjects: Array
  },
  data: function () {
    return {
      message: '',
      showCreateButton: false
    }
  },
  mounted: function () {
    this.refreshMessage()
  },
  methods: {
    create: function () {
      this.$emit('create')
    },
    refreshMessage: function () {
      this.showCreateButton = false

      if (isEmpty(this.androidPackage)) {
        this.message = 'Необходимо заполнить это поле'
        return
      }

      var firebaseProject = this.firebaseProjects.find(p => p.apps.android.find(a => a.package === this.androidPackage))
      if (firebaseProject != null) {
        this.message = `Будет использован проект Firebase "${firebaseProject.name}"`
        return
      }

      this.showCreateButton = true
      this.message = 'Проект в Firebase не найден. '
    }
  },
  watch: {
    androidPackage: function (val) {
      this.refreshMessage()
    }
  }
}
</script>
